
export default function About() {
  return (
    <section id="about" className="relative py-16 md:py-24 bg-gradient-to-b from-gray-900 via-gray-800 to-black overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-64 h-64 bg-orange-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-green-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="mb-12 md:mb-16">
          <div className="inline-block mb-4 px-4 py-1.5 bg-orange-500/20 rounded-full border border-orange-500/30">
            <span className="text-orange-400 text-xs md:text-sm font-semibold tracking-widest uppercase">Quiénes Somos</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4 md:mb-6 max-w-4xl uppercase tracking-wide leading-tight">
            Transformamos Ideas en Realidad Automatizada
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-300 max-w-4xl leading-relaxed text-justify">
            En PACKTO Smart Solutions, convertimos tu visión en máquinas robóticas de última generación. 
            Desde el concepto inicial hasta la entrega final, nuestro equipo de ingenieros especializados 
            diseña y construye soluciones personalizadas con inteligencia artificial integrada. Cada proyecto 
            es único y se adapta a las necesidades específicas de tu negocio, garantizando la máxima 
            eficiencia y retorno de inversión.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="relative">
            <div className="w-full h-full aspect-square rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/1b1c41986ca943bfc9ab2403a34cc919.jpg"
                alt="Máquina de sticks de miel"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-orange-500 to-green-500 rounded-3xl blur-2xl opacity-50"></div>
          </div>

          <div className="space-y-6 md:space-y-8">
            <div className="bg-gray-800/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-gray-700">
              <div className="text-4xl md:text-6xl font-black text-white mb-2" style={{ fontFamily: 'serif' }}>
                +150
              </div>
              <p className="text-gray-300 text-sm md:text-base text-justify">
                Proyectos de automatización completados con éxito en múltiples sectores industriales.
              </p>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-gray-700">
              <div className="text-4xl md:text-6xl font-black bg-gradient-to-r from-orange-500 to-green-500 bg-clip-text text-transparent mb-2" style={{ fontFamily: 'serif' }}>
                24/7
              </div>
              <p className="text-gray-300 text-sm md:text-base text-justify">
                Soporte técnico continuo para todas nuestras soluciones de automatización robótica.
              </p>
            </div>

            <button className="px-6 md:px-8 py-3 md:py-4 bg-white text-gray-900 text-sm md:text-base font-semibold rounded-full hover:shadow-xl transition-all whitespace-nowrap cursor-pointer uppercase tracking-wider">
              Descubre Nuestro Proceso
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
